import React from 'react';

import * as styles from './styles.css';
import PhoneNumber from '../../PhoneNumber';
import { useTranslation } from 'react-i18next';

const PhoneNumberInputModern = ({ isEditable, field, form, disabled, normalize, children, format, showSubmitMsg }) => {
  const { t } = useTranslation();
  const { touched, warning, errors } = form;
  const showError = touched && errors[field.name];
  const hasValue = field.value && field.value !== null;
  const showWarning = !showError && warning;

  const handleChange = (e) => {
    const val = e && e.target ? e.target.value : e;
    form.setFieldValue(field.name, normalize ? normalize(val) : val);
  };
  const handleBlur = (e) => {
    if (format) {
      const formatted = format(form.values[field.name]);
      form.setFieldValue(field.name, formatted);
      form.handleBlur(e);
    }
  };

  if (isEditable === false) {
    return (
      <div className={styles.value}>
        <PhoneNumber isFormatted>{field.value}</PhoneNumber>
      </div>
    );
  }

  return (
    <React.Fragment>
      <input
        {...field}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        className="form-control"
      />
      {showSubmitMsg && (
        <span
          style={{ fontSize: '10px' }}
        >
          {t('Om telefonnumret finns och är aktiverat för engångskodsinloggning skickas ett sms med koden dit. ')}
        </span>
      )}
      {showError && (
        <span
          style={{ color: 'red', fontSize: '10px' }}
        >
          {errors[field.name]}
        </span>
      )}
      {children}
    </React.Fragment>
  );
};

export default PhoneNumberInputModern;
